import { injectable } from 'inversify';
import type {
  IEmailOutboundRepository,
  EmailOutboundDTO,
  ListEmailsParams,
  ListEmailsResult,
} from '@/domain/repositories/IEmailOutboundRepository';
import { httpClient } from '@/infrastructure/http/client/httpClient';

@injectable()
export class ApiEmailOutboundRepository implements IEmailOutboundRepository {
  async list(params: ListEmailsParams = {}): Promise<ListEmailsResult> {
    const query = new URLSearchParams();
    if (params.tenantId) query.set('tenantId', params.tenantId);
    if (params.status) query.set('status', params.status);
    if (params.messageType) query.set('messageType', params.messageType);
    if (params.search) query.set('search', params.search);
    if (params.dateFrom) query.set('dateFrom', params.dateFrom);
    if (params.dateTo) query.set('dateTo', params.dateTo);
    if (params.page) query.set('page', String(params.page));
    if (params.pageSize) query.set('pageSize', String(params.pageSize));

    const qs = query.toString();
    const response = await httpClient.get<ListEmailsResult>(`/emails${qs ? `?${qs}` : ''}`);
    return response.data;
  }

  async getById(id: string): Promise<EmailOutboundDTO> {
    const response = await httpClient.get<EmailOutboundDTO>(`/emails/${encodeURIComponent(id)}`);
    return response.data;
  }
}
